import React from "react";

const PrivacyPolicy = () => (
  <div className="privacy-policy-container rtl">
    <h1>מדיניות פרטיות</h1>
    <p>עודכן לאחרונה: 2 ביוני 2025</p>
    <p>
      מדיניות פרטיות זו מסבירה כיצד אנו אוספים, משתמשים, חושפים ושומרים את המידע האישי שלך כאשר אתה משתמש באפליקציית Rumiz. השימוש שלך בשירות מהווה הסכמה למדיניות זו.
    </p>
    <p>אנו משתמשים במידע האישי שלך כדי לספק ולשפר את השירות. על ידי שימוש בשירות, הנך מסכים לאיסוף ושימוש במידע בהתאם למדיניות פרטיות זו.</p>
    <h2> פרשנות והגדרות</h2>
    <h3>פרשנות</h3>
    <p>למילים שהאות הראשונה שלהן אות גדולה יש משמעויות מוגדרות בתנאים הבאים. להגדרות הבאות תהיה אותה משמעות בין אם הן מופיעות ביחיד או ברבים.
    </p>
    <h3>הגדרות</h3>
    <p>למטרות מדיניות פרטיות זו:
    </p>
    <ul>
      <li><strong>חשבון</strong> - חשבון ייחודי שנוצר עבורך לצורך גישה לשירות או לחלקים ממנו.</li>
      <li><strong>שותף</strong> - כל מי שמעוניין להשתמש בשירות של האפליקציה</li>
      <li><strong>אפליקציה</strong> - אפליקציית Rumiz, תוכנה לחיבור בין אנשים ודירות.</li>
      <li><strong>החברה</strong> - ישות אשר מספקת את האפשרות להשתמש באפליקציה.</li>
      <li><strong>מדינה</strong> - מתייחסת לישראל.</li>
      <li><strong>מכשיר</strong> - פירושו כל מכשיר שיכול להשתמש בשירות.</li>
      <li><strong>מידע אישי</strong> - כל מידע שמזהה אותך באופן אישי.</li>
      <li><strong>שירות</strong> - האפליקציה.</li>
      <li><strong>נתוני שימוש</strong> - כל המידע שנאסף בעת השימוש באפליקציה.</li>
      <li><strong>משתמש</strong> - אדם או גוף המשתמשים באפליקציה.</li>
    </ul>
    <h2>איסוף ושימוש במידע האישי שלך</h2>
    <h3>סוגי מידע שנאסף</h3>
    <h4>מידע אישי</h4>
    <p>בעת השימוש בשירות, יש לספק מידע אישי בשדות המתאימים:</p>
    <ul>
      <li>כתובת דוא"ל</li>
      <li>שם פרטי ושם משפחה</li>
      <li>מספר טלפון</li>
      <li>כתובת, עיר, מיקוד</li>
      <li>נתוני שימוש</li>
    </ul>
    <h4>נתוני שימוש</h4>
    <p>נתוני שימוש נאספים באופן אוטומטי בעת השימוש בשירות.
    </p>
    <p>כאשר אתה ניגש לשירות באמצעות מכשיר נייד, אנו עשויים לאסוף מידע מסוים באופן אוטומטי, לרבות, אך לא רק, סוג המכשיר הנייד בו אתה משתמש, המזהה הייחודי של המכשיר הנייד שלך, כתובת ה-IP של המכשיר הנייד שלך, מערכת ההפעלה הניידת שלך, סוג דפדפן האינטרנט הנייד בו אתה משתמש, מזהי מכשירים ייחודיים ונתוני אבחון אחרים.
    </p>
    <p>אנו עשויים גם לאסוף מידע שהדפדפן שלך שולח בכל פעם שאתה מבקר בשירות שלנו או כאשר אתה ניגש לשירות באמצעות מכשיר נייד.
    </p>
    <h4>מידע שנאסף תוך כדי שימוש באפליקציה</h4>
    <p>במקרים מסוימים, נבקש הרשאה לגשת לתמונות או למצלמה שלך כדי לספק תכונות מסוימות באפליקציה. תוכל לבטל הרשאה זו בכל עת דרך הגדרות המכשיר.</p>
    <h3>שימוש במידע האישי שלך</h3>
    <p>החברה רשאית להשתמש במידע אישי למטרות הבאות:
    </p>
    <ul>
      <li><strong>לספק ולתחזק את השירות</strong> כולל לנטר את השימוש בשירות שלנו.</li>
      <li><strong>לנהל את החשבון שלך</strong>: לנהל את הרישום שלך כמשתמש של השירות. הנתונים האישיים שאתה מספק יכולים לתת לך גישה לפונקציונליות שונה של השירות שזמינה לך כמשתמש רשום.</li>
      <li><strong>ליצור איתך קשר</strong>: ליצור איתך קשר באמצעות דואר אלקטרוני, שיחות טלפון, הודעות SMS או צורות תקשורת אלקטרונית שקולות אחרות, כגון התראות דחיפה של אפליקציה ניידת בנוגע לעדכונים או תקשורת אינפורמטיבית הקשורה לפונקציונליות, מוצרים או שירותים מסופקים, כולל עדכוני אבטחה, כאשר הם הכרחיים או סבירים ליישומם.</li>
      <li><strong>לספק מידע, הצעות ועדכונים</strong>: כדי לספק לך חדשות, ומידע כללי על שירותים ואירועים אחרים שאנו מציעים, אלא אם כן בחרתם שלא לקבל מידע כזה.</li>
      <li><strong>לנהל בקשות שלך</strong>: כדי להשתתף ולנהל את בקשותיך אלינו.
      </li>
      <li><strong>לשפר ולנתח את השירות</strong>: להעריך או לבצע מיזוג, מכירת נכסים, ארגון מחדש, רה-ארגון, פירוק או מכירה או העברה אחרת של חלק מנכסינו או של כולם, בין אם כעסק חי ובין אם כחלק מפשיטת רגל, פירוק או הליך דומה, שבמסגרתו נתונים אישיים המוחזקים על ידינו אודות משתמשי השירות שלנו נמנים בין הנכסים המועברים.</li>
      <li><strong>לעמוד בדרישות החוק</strong>: אנו עשויים להשתמש במידע שלך למטרות אחרות, כגון ניתוח נתונים, זיהוי מגמות שימוש, קביעת יעילות קמפיינים קידום מכירות שלנו ולמטרות להעריך ולשפר את השירות, המוצרים, השירותים, השיווק והחוויה שלך.</li>
    </ul>
    <p>אנו עשויים לשתף את מידע האישי שלך במקרים הבאים:
    </p>
    <ul>
      <li><strong>עם ספקי שירות:</strong> אנו עשויים לשתף את המידע האישי שלך עם ספקי שירות כדי לנטר ולנתח את השימוש בשירות שלנו, ליצור איתך קשר.</li>
      <li><strong>להעברות עסקיות:</strong> אנו עשויים לשתף או להעביר את המידע האישי שלך בקשר עם, או במהלך משא ומתן של, כל מיזוג, מכירת נכסי החברה, מימון או רכישה של כל או חלק מהעסק שלנו לחברה אחרת.</li>
      <li><strong>עם שותפים:</strong> אנו עשויים לשתף את המידע שלך עם השותפים שלנו, ובמקרה זה נדרוש מאותם שותפים לכבד את מדיניות הפרטיות הזו. שותפים כוללים את חברת האם שלנו וכל חברות בת אחרות, שותפים למיזם משותף או חברות אחרות שנמצאות בשליטה שלנו או שנמצאות תחת שליטה משותפת איתנו.</li>
      <li><strong>עם שותפים עסקיים:</strong> אנו עשויים לשתף את המידע שלך עם השותפים העסקיים שלנו כדי להציע לך מוצרים, שירותים או מבצעים מסוימים.</li>
      <li><strong>עם משתמשים אחרים:</strong> כאשר אתה משתף מידע אישי או מקיים אינטראקציה בשטחים ציבוריים עם משתמשים אחרים, מידע כזה עשוי להיראות על ידי כל המשתמשים ועשוי להיות מופץ באופן ציבורי מחוץ לשירות.</li>
      <li><strong>עם הסכמתך</strong>: אנו עשויים לגלות את המידע האישי שלך לכל מטרה אחרת בהסכמתך.</li>
    </ul>
    <h3>שמירת מידע</h3>
    <p>החברה תשמור את הנתונים האישיים שלך רק כל עוד יהיה צורך למטרות המפורטות במדיניות פרטיות זו. אנו נשמור ונשתמש בנתונים האישיים שלך במידה הדרושה לציות להתחייבויות המשפטיות שלנו (לדוגמה, אם אנו נדרשים לשמור את הנתונים שלך כדי לציית לחוקים החלים), ליישב מחלוקות ולאכוף את ההסכמים והמדיניות המשפטיים שלנו.</p>
    <p>החברה תשמור גם נתוני שימוש למטרות ניתוח פנימי. נתוני שימוש נשמרים בדרך כלל לפרק זמן קצר יותר, למעט כאשר נתונים אלה משמשים לחיזוק האבטחה או לשיפור הפונקציונליות של השירות שלנו, או שאנו מחויבים משפטית לשמור נתונים אלה לפרקי זמן ארוכים יותר.</p>
    <h3>העברת מידע</h3>
    <p>המידע שלך, כולל נתונים אישיים, מעובד במשרדי החברה ובכל מקום אחר בו נמצאים הצדדים המעורבים בעיבוד. משמעות הדבר היא שמידע זה עשוי להיות מועבר - ותשמר - במחשבים הממוקמים מחוץ למדינה, למחוז, למדינה או לתחום שיפוט ממשלתי אחר שלך, שבהם חוקי הגנת המידע עשויים להיות שונים מאלה שבתחום השיפוט שלך.</p>
    <p>הסכמתך למדיניות פרטיות זו ולאחר מכן הגשת מידע זה מייצגת את הסכמתך להעברה זו.</p>
    <p>החברה תנקוט בכל הצעדים הסבירים הנדרשים כדי להבטיח שהנתונים שלך יטופלו בצורה מאובטחת ובהתאם למדיניות פרטיות זו, ולא תתבצע העברה של הנתונים האישיים שלך לארגון או למדינה אלא אם כן קיימות בקרות נאותות, לרבות אבטחת הנתונים שלך ומידע אישי אחר.</p>
    <h3>מחיקת מידע</h3>
    <p>יש לך את הזכות למחוק או לבקש מאיתנו לסייע במחיקת המידע האישי שאספנו אודותיך.</p>
    <p>השירות שלנו עשוי לאפשר לך למחוק מידע מסוים אודותיך מתוך השירות.</p>
    <p>באפשרותך לעדכן, לתקן או למחוק את המידע שלך בכל עת על ידי כניסה לחשבונך, אם יש לך כזה, וביקור במקטע הגדרות החשבון המאפשר לך לנהל את המידע האישי שלך. באפשרותך גם ליצור איתנו קשר כדי לבקש גישה למידע אישי שסיפקת לנו, לתקן או למחוק אותו.</p>
    <p>שימו לב, עם זאת, כי ייתכן שנצטרך לשמור מידע מסוים כאשר יש לנו חובה חוקית או בסיס חוקי לעשות זאת.</p>
    <h3>גילוי מידע</h3>
    <h4>עסקאות עסקיות</h4>
    <p>אם החברה מעורבת במיזוג, רכישה או מכירת נכסים, ייתכן שהנתונים האישיים שלך יועברו. אנו נספק הודעה לפני שהנתונים האישיים שלך יועברו ויהפכו לכפופים למדיניות פרטיות שונה.</p>
<h4>אכיפת חוק</h4>
<p>בנסיבות מסוימות, ייתכן שהחברה תידרש לחשוף את הנתונים האישיים שלך אם הדבר נדרש על פי חוק או בתגובה לבקשות תקפות של רשויות ציבוריות (למשל, בית משפט או סוכנות ממשלתית).</p>
<h4>דרישות משפטיות אחרות</h4>
<p>החברה רשאית לחשוף את הנתונים האישיים שלך מתוך אמונה בתום לב שפעולה כזו נחוצה כדי:</p>
<ul>
<li>לעמוד בחובה חוקית</li>
<li>להגן ולהגן על זכויותיה או רכושה של החברה</li>
<li>למנוע או לחקור עוולות אפשריות בקשר לשירות</li>
<li>להגן על הבטיחות האישית של משתמשי השירות או הציבור</li>
<li>להגן מפני אחריות משפטית</li>
</ul>
    <h3>אבטחת מידע</h3>
    <p>אבטחת המידע האישי שלך חשובה לנו, אך זכור כי אף שיטת העברה באינטרנט, או שיטת אחסון אלקטרונית, אינה מאובטחת ב-100%. בעוד שאנו שואפים להשתמש באמצעים מקובלים מבחינה מסחרית כדי להגן על המידע האישי שלך, איננו יכולים להבטיח את אבטחתו המוחלטת.</p>
    <h2>פרטיות ילדים</h2>
    <p>השירות שלנו אינו פונה לאף אחד מתחת לגיל 13. איננו אוספים ביודעין מידע מזהה אישי מאף אחד מתחת לגיל 13. אם אתה הורה או אפוטרופוס ואתה מודע לכך שילדך סיפק לנו נתונים אישיים, אנא צור איתנו קשר. אם אנו נהיה מודעים לכך שאספנו נתונים אישיים מאף אחד מתחת לגיל 13 ללא אימות של הסכמת הורים, אנו נוקטים בצעדים כדי להסיר מידע זה מהשרתים שלנו.</p>
    <p>אם אנו צריכים להסתמך על הסכמה כבסיס משפטי לעיבוד המידע שלך והמדינה שלך דורשת הסכמה מהורה, אנו עשויים לדרוש את הסכמת ההורה שלך לפני שנאסוף ונשתמש במידע זה.

</p>
    <h2>קישורים לאתרים אחרים</h2>
    <p>השירות שלנו עשוי להכיל קישורים לאתרים אחרים שאינם מופעלים על ידינו. אם אתה לוחץ על קישור של צד שלישי, תופנה לאתר של אותו צד שלישי. אנו ממליצים לך בחום לעיין במדיניות הפרטיות של כל אתר שאתה מבקר בו.

</p>
    <p>אין לנו שליטה ואיננו נוטלים אחריות על התוכן, מדיניות הפרטיות או הנהלים של כל אתר או שירות של צד שלישי.
</p>
    <h2>שינויים במדיניות פרטיות זו</h2>
    <p>אנו עשויים לעדכן את מדיניות הפרטיות שלנו מעת לעת. נודיע לך על כל שינוי על ידי פרסום מדיניות הפרטיות החדשה בדף זה.</p>
    <p>אנו נודיע לך באמצעות דואר אלקטרוני ו/או הודעה בולטת בשירות שלנו, לפני שהשינוי ייכנס לתוקף ונעדכן את תאריך &quot;העדכון האחרון&quot; בראש מדיניות פרטיות זו.</p>
    <p>מומלץ לך לעיין במדיניות פרטיות זו באופן תקופתי לכל שינוי. שינויים במדיניות פרטיות זו נכנסים לתוקף כאשר הם מפורסמים בדף זה.</p>
    <h2>צור קשר</h2>
    <p>באמצעות דואר אלקטרוני: <a href="mailto:rumiz.mail12@gmail.com">rumiz.mail12@gmail.com</a></p>
    <p>התוכן פונה הן לגברים והן לנשים, ונכתב בלשון זכר לשם נוחות.</p>

  </div>
);

export default PrivacyPolicy; 